import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Components
import Badge from "components/Badge";

ShipmentCountBadge.propTypes = {
    count: PropTypes.number.isRequired,
};

function ShipmentCountBadge({count}) {
    return (
        <Badge
            rounded={true}
            size={'large'}
            isBold={false}
        >
            {count} <FormattedMessage id={count === 1 ? 'wms.shipping.shipment' : 'wms.shipping.shipments' } />
        </Badge>
    );
}

export default ShipmentCountBadge;
